import { Injectable } from '@angular/core';
import { DatabaseWrapper, DatabaseWrapperProvider, TransactionId } from 'services/database-wrapper';
import { AuthService } from 'services/auth.service';
import { PouchDoc } from '@cf-shared/data-model/pouch';
import { AuthRole } from '@cf-shared/couch-auth';
import { WorkoutSolverExercise } from '@cf-shared/workout-solver-interface';

export class WorkoutTestCase extends PouchDoc {
  // full name of the test
  name: string;
  testWorkoutSolverJSON: string;
  approvedResultDays?: WorkoutSolverExercise[][];
  approvedBy?: string[];
}

@Injectable()
export class TestCasesDbService {
  database: DatabaseWrapper;

  constructor(private auth: AuthService, private dbProvider: DatabaseWrapperProvider) {}

  async initializeAsync() {
    // ordinary users cannot access the database of test cases
    if (this.auth.getAuthRole() < AuthRole.Officer) {
      return;
    }
    if (this.database?.getReadDb() != null) {
      return;
    }
    this.database = this.dbProvider.createDatabaseWrapper();
    await this.database.initAsSharedDatabaseAsync(this.auth.user, 'global_testcases');
  }

  async shutdownAsync() {
    if (this.database) {
      await this.database.shutdownAsync();
    }
  }

  async getAllWorkoutTestCasesAsync(): Promise<WorkoutTestCase[]> {
    // no catch: an empty list would read as "there are no test cases" on the test page.
    // a failed load travels up to the page and the global handler instead (#5191)
    let docs = await this.database.getAllDataUncachedAsync();
    return (docs as WorkoutTestCase[]).filter(t => t._id.startsWith('test/workout/'));
  }

  async saveWorkoutTestCaseAsync(e: WorkoutTestCase, transaction: TransactionId): Promise<void> {
    // awaited rather than returned: saveRecordAsync now answers with what became of the
    // write (df-068808a2796e), and that answer is for the delete paths, not for here.
    await this.database.saveRecordAsync(e, transaction);
  }

  async deleteWorkoutTestCaseAsync(e: WorkoutTestCase, transaction: TransactionId): Promise<void> {
    return this.database.deleteRecordAsync(e, transaction);
  }
}
